export { BvlButtonComponent as BvlButton } from './button.component';
export { BvlButtonModule } from './button.module';
